<template>
  <div class="equipment-tab">
    <div class="row">
      <GearPreview @update="equipmentChanged" :equipment="equipment"></GearPreview>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <EquipmentCost :equipment="equipment" :prices="itemPrices"></EquipmentCost>
      </div>
    </div>
  </div>
</template>

<script>
  import EquipmentCost from "../gear-selector/EquipmentCost";
  import GearPreview from "../gear-selector/GearPreview";

  export default {
    name: "EquipmentTab",
    components: {GearPreview, EquipmentCost},
    props: {
      equipment: {
        type: Object,
      }
    },
    data() {
      return {
        itemPrices: {}
      }
    },
    methods: {
      equipmentChanged: function (slot, item) {
        this.$emit('equipmentChanged', slot, item)
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabs/EquipmentTab.vue